import React from 'react'
import { formatPrice } from '../../../helpers'
import StatusBadge from './StatusBadge'

const TransactionModal = ({ modalTrx, onClose }) => {
  if (!modalTrx) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          maxWidth: '550px',
          width: '100%',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#fafafa'
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '3px' }}>
              <h3 style={{ margin: 0, fontSize: '1.1em', fontWeight: 'bold', color: '#F5152C', textTransform: 'uppercase' }}>
                Detail Pesanan: {modalTrx.code}
              </h3>
              <StatusBadge status={modalTrx.status} />
            </div>
            <span style={{ fontSize: '0.85em', color: '#777' }}>
              Total {modalTrx.orders?.length || 0} Produk • <span style={{ fontSize: '1.1em', fontWeight: '800', color: '#fa591d' }}>{formatPrice(modalTrx.total, 'Rp.')}</span>
            </span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5em',
              cursor: 'pointer',
              color: '#888',
              outline: 'none',
              lineHeight: 1
            }}
          >
            &times;
          </button>
        </div>

        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          {modalTrx.orders && modalTrx.orders.map((item, itemIdx) => (
            <div
              key={item.id || itemIdx}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 12px',
                background: '#f9f9f9',
                borderRadius: '6px',
                marginBottom: '10px',
                fontSize: '0.9em',
                border: '1px solid #eee'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {item.product?.image && (
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + item.product.image}
                    alt={item.product?.name}
                    style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }}
                  />
                )}
                <div>
                  <span style={{ fontWeight: '600', color: '#333' }}>{item.product?.name || `Produk #${item.product_id}`}</span>
                  <div style={{ color: '#777', fontSize: '0.9em', marginTop: '2px' }}>
                    {item.quantity} x {formatPrice(item.price, 'Rp.')}
                  </div>
                </div>
              </div>
              <div style={{ fontWeight: 'bold', color: '#222' }}>
                {formatPrice(Number(item.price) * item.quantity, 'Rp.')}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            padding: '12px 20px',
            borderTop: '1px solid #eee',
            textAlign: 'right',
            backgroundColor: '#fafafa'
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: '8px 20px',
              background: '#F5152C',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '0.9em',
              outline: 'none'
            }}
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  )
}

export default TransactionModal
